import o from "./ApiGuide.vue2.js";
import "./ApiGuide.vue3.js";
import t from "./_virtual/_plugin-vue_export-helper.js";
const e = /* @__PURE__ */ t(o, [["__scopeId", "data-v-4b6af3eb"]]);
export {
  e as default
};
